import Vue from 'vue';
import Vuex from 'vuex';
import Sample from '../assets/data/EIoF3.json';
import region_1_sankey from '../assets/data/NW_SankeyJSON_2016.json';
import region_2_sankey from '../assets/data/CA_SankeyJSON_2016.json';
import region_3_sankey from '../assets/data/MN_SankeyJSON_2016.json';
import region_4_sankey from '../assets/data/SW_SankeyJSON_2016.json';
import region_5_sankey from '../assets/data/CE_SankeyJSON_2016.json';
import region_6_sankey from '../assets/data/TX_SankeyJSON_2016.json';
import region_7_sankey from '../assets/data/MW_SankeyJSON_2016.json';
import region_8_sankey from '../assets/data/AL_SankeyJSON_2016.json';
import region_9_sankey from '../assets/data/MA_SankeyJSON_2016.json';
import region_10_sankey from '../assets/data/SE_SankeyJSON_2016.json';
import region_11_sankey from '../assets/data/FL_SankeyJSON_2016.json';
import region_12_sankey from '../assets/data/NY_SankeyJSON_2016.json';
import region_13_sankey from '../assets/data/NE_SankeyJSON_2016.json';
// import region from './modules/region';
// import sankey from './modules/sankey';
import JQuery, { data } from 'jquery';
import axios from 'axios';
import { link, stat } from 'fs';
import { window, local, stackOffsetWiggle } from 'd3';

//Load Vuex
Vue.use(Vuex);

const techMixInputs = [
  'Petroleum',
  'Nuclear',
  'Natural Gas',
  'Hydro',
  'Wind',
  'Coal',
  'Solar PV',
  'Solar CSP',
  'Biomass',
  'Geothermal'
];

const $ = JQuery;

//Create store
export default new Vuex.Store({
  modules: {
    // region,
    // sankey
  },
  state: {
    version: '1.0.1',
    genDate: '08/19/2020',
    loadResults: true,
    inputWarningModal: false,
    inputWarningModalReported: false,
    lightDutyWarningModal: false,
    lightDutyWarningModalReported: true,
    inputWarningShareReport: false,
    loading: false,
    storage: false,
    inputs: {
      'Natural Gas': 53,
      'Geothermal': 0,
      'Nuclear': 8,
      'Petroleum': 0,
      'Hydro': 0,
      'Biomass': 0,
      'Wind': 10,
      'Solar PV': 5,
      'Solar CSP': 1,
      'Coal': 23
    },
    techMixSum: 100,
    heatingSum: 100,
    region_id: 6,
    r_sh_e: 13,
    r_sh_ng: 58,
    r_sh_o: 29,
    ldv_e: 13,
    ng_percent: 53,
    geothermal_percent: 0,
    nuclear_percent: 8,
    petroleum_percent: 0,
    hydro_percent: 0,
    biomass_percent: 0,
    wind_percent: 10,
    CSP_percent: 1,
    PV_percent: 5,
    coal_percent: 23,
    ldv_driven_percent: 13,
    ldv_liquid_percent: 87,
    heatingInputs: {
      'Natural Gas': {value: 58, max: 100},
      'Electricity': {value: 13, max: 100},
      'Other (e.g. Biomass, Petrol)': {value: 29, max: 29}
    },
    ldvInputs: {
      'Electricity': 13,
      'Petrol+Biofuel blend': 87
    },
    sankey: {
      links: [],
      nodes: []
    },
    shareSankey: {
      links: [],
      nodes: []
    },
    sankeyRegion: region_6_sankey,
    testSankey: [],
    timeSeries: {
      "Hourly_MW_AnnualStorage": [],
      "Hourly_MW_NoStorage": [],
      "DollarPerYearStorage": {
        "pp_capex": [],
        "t_and_d_capex": [],
        "pp_opex": [],
        "t_and_d_opex": [],
        "pet_industrial": [],
        "pet_commercial": [],
        "pet_transport": [],
        "pet_res": [],
        "ng_industrial": [],
        "ng_commercial": [],
        "ng_transport": [],
        "ng_res": [],
        "coal_non_elec": [],
        "all_pp_opex": [], 
        "all_pp_capex": [], 
        "TandD_opex": [], 
        "TandD_capex": [], 
        "oil_indus_spending": [], 
        "oil_commerce_spending": [], 
        "oil_transport_spending": [], 
        "oil_resid_spending": [], 
        "ng_indus_spending": [], 
        "ng_commerce_spending": [], 
        "ng_transport_spending": [], 
        "ng_resid_spending": [], 
        "coal_not_elec": [], 
        "all_pp_opex_GDP": [], 
        "all_pp_capex_GDP": [], 
        "TandD_opex_GDP": [], 
        "TandD_capex_GDP": [], 
        "oil_indus_spending_GDP": [], 
        "oil_commerce_spending_GDP": [], 
        "oil_transport_spending_GDP": [], 
        "oil_resid_spending_GDP": [], 
        "ng_indus_spending_GDP": [], 
        "ng_commerce_spending_GDP": [], 
        "ng_transport_spending_GDP": [], 
        "ng_resid_spending_GDP": [], 
        "coal_not_elec_GDP": [], 
      },
      "DollarPerYearNoStorage": {
        "pp_capex": [],
        "t_and_d_capex": [],
        "pp_opex": [],
        "t_and_d_opex": [],
        "pet_industrial": [],
        "pet_commercial": [],
        "pet_transport": [],
        "pet_res": [],
        "ng_industrial": [],
        "ng_commercial": [],
        "ng_transport": [],
        "ng_res": [],
        "coal_non_elec": [],
        "all_pp_opex": [], 
        "all_pp_capex": [], 
        "TandD_opex": [], 
        "TandD_capex": [], 
        "oil_indus_spending": [], 
        "oil_commerce_spending": [], 
        "oil_transport_spending": [], 
        "oil_resid_spending": [], 
        "ng_indus_spending": [], 
        "ng_commerce_spending": [], 
        "ng_transport_spending": [], 
        "ng_resid_spending": [], 
        "coal_not_elec": [], 
        "all_pp_opex_GDP": [], 
        "all_pp_capex_GDP": [], 
        "TandD_opex_GDP": [], 
        "TandD_capex_GDP": [], 
        "oil_indus_spending_GDP": [], 
        "oil_commerce_spending_GDP": [], 
        "oil_transport_spending_GDP": [], 
        "oil_resid_spending_GDP": [], 
        "ng_indus_spending_GDP": [], 
        "ng_commerce_spending_GDP": [], 
        "ng_transport_spending_GDP": [], 
        "ng_resid_spending_GDP": [], 
        "coal_not_elec_GDP": [],
      },
      "EmissionsStorage": {
        "Total_Emissions": [],
        "Coal": [],
        "Natural Gas": [],
        "Petroleum": [],
        "Embodied": []
      },
      "EmissionsNoStorage": {
        "Total_Emissions": [],
        "Coal": [],
        "Natural Gas": [],
        "Petroleum": [],
        "Embodied": []
      },
      "CapacityStorage": {},
      "CapacityNoStorage": {}
    },
    timeSeriesMW: [],
    timeSeriesMWNoStorage: [],
    timeSeriesDollar: {},
    timeSeriesDollarNoStorage: {},
    timeSeriesEmissions: {},
    timeSeriesEmissionsNoStorage: {},
    timeSeriesCapacity: {},
    timeSeriesCapacityNoStorage: {},
    summaryChartStorage: {
      'Natural Gas': [],
      'Geothermal': [],
      'Nuclear': [],
      'Petroleum': [],
      'Hydro': [],
      'Biomass': [],
      'Wind': [],
      'Solar PV': [],
      'Solar CSP': [],
      'Coal': []
    },
    summaryChartNoStorage: {
      'Natural Gas': [],
      'Geothermal': [],
      'Nuclear': [],
      'Petroleum': [],
      'Hydro': [],
      'Biomass': [],
      'Wind': [],
      'Solar PV': [],
      'Solar CSP': [],
      'Coal': []
    },
    summaryChartInputs: {
      'Natural Gas': [],
      'Geothermal': [],
      'Nuclear': [],
      'Petroleum': [],
      'Hydro': [],
      'Biomass': [],
      'Wind': [],
      'Solar PV': [],
      'Solar CSP': [],
      'Coal': []
    },
    shareModalPPCapacityStorage: {
      'Natural Gas': [],
      'Geothermal': [],
      'Nuclear': [],
      'Petroleum': [],
      'Hydro': [],
      'Biomass': [],
      'Wind': [],
      'Solar PV': [],
      'Solar CSP': [],
      'Coal': []
    }, 
    shareModalPPCapacityNoStorage: {
      'Natural Gas': [],
      'Geothermal': [],
      'Nuclear': [],
      'Petroleum': [],
      'Hydro': [],
      'Biomass': [],
      'Wind': [],
      'Solar PV': [],
      'Solar CSP': [],
      'Coal': []
    },
    ngGenStorage: 0,
    ngGenNoStorage: 0,
    geoGenStorage: 0,
    geoGenNoStorage: 0,
    nuclearGenStorage: 0,
    nuclearGenNoStorage: 0,
    petGenStorage: 0,
    petGenNoStorage: 0,
    hydroGenStorage: 0,
    hydroGenNoStorage: 0,
    bioGenStorage: 0,
    bioGenNoStorage: 0,
    windGenStorage: 0,
    windGenNoStorage: 0,
    pvGenStorage: 0,
    pvGenNoStorage: 0,
    cspGenStorage: 0,
    cspGenNoStorage: 0,
    coalGenStorage: 0,
    coalGenNoStorage: 0,
    totalGenStorage: 0,
    totalGenNoStorage: 0,
    warningModal: {},
    warningModalNoStorage: {},
    capPowerStorage: 0,
    capEnergyStorage: 0,
    capPowerNoStorage: 0,
    capEnergyNoStorage: 0,
    ppCapStorage: 0,
    ppCapStorage_2016: 0,
    netGenStorage: 0,
    ppCapNoStorage: 0,
    netGenNoStorage: 0,
    totalElecCostStorage: 0,
    totalElecCostNoStorage: 0,
    capitalElecCostStorage: 0,
    capitalElecCostNoStorage: 0,
    operatingElecCostStorage: 0,
    operatingElecCostNoStorage: 0,
    elecCostPerCustomerStorage: 0,
    elecCostPerCustomerNoStorage: 0,
    elecCostPerPersonStorage: 0,
    elecCostPerPersonNoStorage: 0,
    landUseStorage: 0,
    landUseNoStorage: 0,
    landUsePercentStorage: 0,
    landUsePercentNoStorage: 0,
    landUseStorageDirect: 0,
    landUseNoStorageDirect: 0,
    landUsePercentStorageDirect: 0,
    landUsePercentNoStorageDirect: 0,
    pimaryEnergySummary: {}
  },
  methods: {},
  getters: {
    allInputs: state => {
      return state.inputs;
    },
    allLightDuty: state => {
      return state.ldvInputs
    },
    allHeatingInputs: state => {
      return state.heatingInputs;
    },
    getldv_e: state => {
      return state.ldv_driven_percent;
    },
    getOtherldv_e: state => {
      return 100 - state.ldv_driven_percent
    },
    allSankey: state => {
      return state.sankey;
    },
    getShareSankey: state => {
      let data = state.sankeyRegion.links;
      data.forEach(link => {
        delete link['Product'];
        delete link['edge_id'];
        delete link['From_node_id'];
        delete link['To_node_id'];
        delete link['type'];
        if (link['From']) {
          if (link['From'].includes('_')) {
            let newLink = link['From'].replace(/_/g, ' ');
            link.source = newLink;
          } else {
            link.source = link['From'];
          }
        }
        if (link['To']) {
          if (link['To'].includes('_')) {
            let newTarget = link['To'].replace(/_/g, ' ');
            link.target = newTarget;
          } else {
            link.target = link['To'];
          }
        }
        if (link['Value']) {
          link.value = link['Value'];
        }
        delete link['From'];
        delete link['To'];
        delete link['Value'];
      });

      let final = data;

      state.shareSankey.links = final;

      let data2 = state.sankeyRegion.nodes;
      data2.forEach(node => {
        if (node['Node'].includes('_')) {
          let newNode = node['Node'].replace(/_/g, ' ');
          node.name = newNode;
        } else {
          node.name = node['Node'];
        }
        delete node['Node'];
        delete node['node_id'];
        delete node['type'];
      });

      let final2 = data2;

      state.shareSankey.nodes = final2;
      
      return state.shareSankey
    },
    getShareModal2016CSPData: state => {
      if (state.region_id === 2) {
        return 2.46
      } else if (state.region_id === 3) {
        0.32
      } else if (state.region_id === 4) {
        return 0.53
      } else {
        return 0
      }
    },
    getShareModal2016CSPPercentData: state => {
      if (state.region_id === 2) {
        return 1.25
      } else if (state.region_id === 3) {
        return 0.14
      } else if (state.region_id === 4) {
        return 0.38
      } else {
        return 0
      }
    },
    allTestSankey: state => {
      return state.testSankey;
    },
    allMWOutput: state => {
      return state.timeSeriesMW
    },
    allMWOutputNoStorage: state => {
      return state.timeSeriesMWNoStorage
    },
    inputsSum: state => {
      return state.techMixSum;
    },
    householdSum: state => {
      return state.heatingSum;
    },
    loadedBool: state => {
      return state.loading;
    },
    getInputWarningModal: state => {
      return state.warningModal
    },
    getInputWarningModalNoStorage: state => {
      return state.warningModalNoStorage
    },
    getRegionName: state => {
      if (state.region_id === 1) {
        return "Northwest"
      } else if (state.region_id === 2) {
        return "California"
      } else if (state.region_id === 3) {
        return "Mountain North"
      } else if (state.region_id === 4) {
        return "Southwest"
      } else if (state.region_id === 5) {
        return "Central"
      } else if (state.region_id === 6) {
        return "Texas"
      } else if (state.region_id === 7) {
        return "Midwest"
      } else if (state.region_id === 8) {
        return "Arkansas Louisiana"
      } else if (state.region_id === 9) {
        return "Mid Atlantic"
      } else if (state.region_id === 10) {
        return "Southeast"
      } else if (state.region_id === 11) {
        return "Florida"
      } else if (state.region_id === 12) {
        return "New York"
      } else {
        return "New England"
      }
    },
    storageCapPower: state => {
      var parts = state.capPowerStorage.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts[0];
      // return state.capPowerStorage
    },
    storageCapEnergy: state => {
      var parts = state.capEnergyStorage.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (parts[1]) {
        parts[1] = parts[1].slice(0, 1)
      }
      return parts.join(".");
      // return state.capEnergyStorage
    },
    storageCapPowerNoStorage: state => {
      var parts = state.capPowerNoStorage.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts[0];
      // return state.capPowerNoStorage
    },
    storageCapEnergyNoStorage: state => {
      var parts = state.capEnergyNoStorage.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      
      return parts.join(".");
      
      // return state.capPowerNoStorage
    },
    powerPlantCapacityStorage: state => {
      var parts = state.ppCapStorage.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts[0];
      // return state.ppCapStorage
    },
    totalNetGenStorage: state => {
      var parts = state.netGenStorage.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts[0];
      // return state.netGenStorage
    },
    powerPlantCapacityNoStorage: state => {
      var parts = state.ppCapNoStorage.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts[0];
      // return state.ppCapNoStorage
    },
    totalNetGenNoStorage: state => {
      var parts = state.netGenNoStorage.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts[0];
      // return state.netGenNoStorage
    },
    totalElecCostStorageGetter: state => {
      return state.totalElecCostStorage.toFixed(1)
    },
    totalElecCostNoStorageGetter: state => {
      return state.totalElecCostNoStorage.toFixed(1)
    },
    capitalElecCostStorageGetter: state => {
      return state.capitalElecCostStorage.toFixed(1)
    },
    capitalElecCostNoStorageGetter: state => {
      return state.capitalElecCostNoStorage.toFixed(1)
    },
    operatingElecCostStorageGetter: state => {
      return state.operatingElecCostStorage.toFixed(1)
    },
    operatingElecCostNoStorageGetter: state => {
      return state.operatingElecCostNoStorage.toFixed(1)
    },
    elecCostPerCustomerStorageGetter: state => {
      return state.elecCostPerCustomerStorage.toFixed(1)
    },
    elecCostPerCustomerNoStorageGetter: state => {
      return state.elecCostPerCustomerNoStorage.toFixed(1)
    },
    elecCostPerPersonStorageGetter: state => {
      return state.elecCostPerPersonStorage.toFixed(1)
    },
    elecCostPerPersonNoStorageGetter: state => {
      return state.elecCostPerPersonNoStorage.toFixed(1)
    },
    getLandUseStorage: state => {
      return state.landUseStorage.toFixed(0)
    },
    getLandUseNoStorage: state => {
      return state.landUseNoStorage.toFixed(0)
    },
    getLandUsePercentStorage: state => {
      return state.landUsePercentStorage.toFixed(1);
    },
    getLandUsePercentNoStorage: state => {
      return state.landUsePercentNoStorage.toFixed(1);
    },
    getLandUseStorageDirect: state => {
      return state.landUseStorageDirect.toFixed(0)
    },
    getLandUseNoStorageDirect: state => {
      return state.landUseNoStorageDirect.toFixed(0)
    },
    getLandUsePercentStorageDirect: state => {
      return state.landUsePercentStorageDirect.toFixed(1);
    },
    getLandUsePercentNoStorageDirect: state => {
      return state.landUsePercentNoStorageDirect.toFixed(1);
    },
    getDate: state => {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      today = mm + '/' + dd + '/' + yyyy; 
      return today
    }
  },
  actions: {
    fetchSampleSankeyLinks({ commit }) {
      commit('setSampleSankeyLinks', Sample.sankey_links);
    },
    fetchSampleSankeyNodes({ commit }) {
      commit('setSampleSankeyNodes', Sample.sankey_nodes);
    },
    fetchSampleTimeSeriesOutput({ commit }) {
      commit('setSankeyLinks', Sample.sankey_links);
      commit('setSankeyNodes', Sample.sankey_nodes);
      commit('setSummaryChartStorage', Sample["PPdata_AnnualStorage"])
      commit('setSummaryChartNoStorage', Sample["PPdata_NoStorage"])
      commit('setElectricityCosts', Sample["elec_cost_summary_2050"])
      commit('setSummaryChartInputs', Sample["website_inputs"])
      commit('setTimeSeriesGGSheetNoStorage', Sample["ggsheets_output_NoStorage"])
      commit('setTimeSeriesGGSheet', Sample["ggsheets_output_AnnualStorage"])
      commit('setTimeSeriesMWOutput', Sample["Hourly_MW_AnnualStorage"])
      commit('setTimeSeriesMWNoStorage', Sample["Hourly_MW_NoStorage"])
      commit('setEnergySummary', Sample["PrimaryEnergySummary"])
    },

    fetchInputs({ commit }) {
      commit('setLoaded', true);
      commit('setReadyToLoad', true)
      commit('setLoadingModal', true)
      // this.$_vm.$bvModal.show('modal-hold');
      axios
        .get('http://EC2Co-EcsEl-17G8EK974H6BW-2259133.us-east-2.elb.amazonaws.com:8000/eiof?region_id=' + this.state.region_id + 
        '&r_sh_e=' + this.state.r_sh_e +
        '&r_sh_ng=' + this.state.r_sh_ng + 
        '&ldv_e=' + this.state.ldv_driven_percent + 
        '&ng_percent=' + this.state.ng_percent + 
        '&geothermal_percent=' + this.state.geothermal_percent + 
        '&nuclear_percent=' + this.state.nuclear_percent + 
        '&petroleum_percent=' + this.state.petroleum_percent + 
        '&hydro_percent=' + this.state.hydro_percent + 
        '&biomass_percent=' + this.state.biomass_percent + 
        '&wind_percent=' + this.state.wind_percent + 
        '&CSP_percent=' + this.state.CSP_percent + 
        '&PV_percent=' + this.state.PV_percent + 
        '&coal_percent=' + this.state.coal_percent)
        .then(response => {
          if (this.state.loadResults) {
            commit('setSankeyLinks', response.data.sankey_links);
            commit('setSankeyNodes', response.data.sankey_nodes);
            commit('setTestSankey', response.data.sankey_links);
            commit('setSummaryChartStorage', response.data["PPdata_AnnualStorage"], response.data["website_inputs"])
            commit('setSummaryChartNoStorage', response.data["PPdata_NoStorage"])
            commit('setElectricityCosts', response.data["elec_cost_summary_2050"])
            commit('setSummaryChartInputs', response.data["website_inputs"])
            commit('setTimeSeriesGGSheetNoStorage', response.data["ggsheets_output_NoStorage"])
            commit('setTimeSeriesGGSheet', response.data["ggsheets_output_AnnualStorage"])
            commit('setTimeSeriesMWOutput', response.data["Hourly_MW_AnnualStorage"])
            commit('setTimeSeriesMWNoStorage', response.data["Hourly_MW_NoStorage"])
            commit('setEnergySummary', response.data["PrimaryEnergySummary"])
            commit('setLoaded', false);
          }
        })
        .catch(err => {
        });
    },
    toggleStorage({ commit }) {
      commit('setToggleStorage')
    },
    changeInput({ commit }, data) {
      commit('setNewInput', data);
    },
    changeLDV({ commit }, data) {
      commit('setLDV', data)
    },
    changeHeating({ commit }, data) {
      commit('setHeating', data)
    },
    changeOtherLDV({ commit }, data) {
      commit('setOtherLDV', data)
    },
    changeRegion({ commit }, id) {
      let newID = id
      let retrievedLocalStorage = JSON.parse(localStorage.getItem(`${id}`))
      if (retrievedLocalStorage === null) {
        commit('setNewRegion', id);
      } else {
        commit('loadStoredRegion', retrievedLocalStorage, id)
        commit('setLoaded', true);
        axios
          .get('http://EC2Co-EcsEl-17G8EK974H6BW-2259133.us-east-2.elb.amazonaws.com:8000/eiof?region_id=' + newID + 
          '&r_sh_e=' + retrievedLocalStorage['Heating Elec'] +
          '&r_sh_ng=' + retrievedLocalStorage['Heating NG'] + 
          '&ldv_e=' + this.state.ldv_driven_percent + 
          '&ng_percent=' + retrievedLocalStorage['Natural Gas'] + 
          '&geothermal_percent=' + retrievedLocalStorage['Geothermal'] + 
          '&nuclear_percent=' + retrievedLocalStorage['Nuclear'] + 
          '&petroleum_percent=' + retrievedLocalStorage['Petroleum'] + 
          '&hydro_percent=' + retrievedLocalStorage['Hydro'] + 
          '&biomass_percent=' + retrievedLocalStorage['Biomass'] + 
          '&wind_percent=' + retrievedLocalStorage['Wind'] + 
          '&CSP_percent=' + retrievedLocalStorage['Solar CSP'] + 
          '&PV_percent=' + retrievedLocalStorage['Solar PV'] + 
          '&coal_percent=' + retrievedLocalStorage['Coal'])
          .then(response => {
            if (this.state.loadResults) {
              commit('setSankeyLinks', response.data.sankey_links);
              commit('setSankeyNodes', response.data.sankey_nodes);
              commit('setTestSankey', response.data.sankey_links);
              commit('setSummaryChartStorage', response.data["PPdata_AnnualStorage"], response.data["website_inputs"])
              commit('setSummaryChartNoStorage', response.data["PPdata_NoStorage"])
              commit('setTimeSeriesGGSheetNoStorage', response.data["ggsheets_output_NoStorage"])
              commit('setTimeSeriesGGSheet', response.data["ggsheets_output_AnnualStorage"])
              commit('setTimeSeriesMWOutput', response.data["Hourly_MW_AnnualStorage"])
              commit('setTimeSeriesMWNoStorage', response.data["Hourly_MW_NoStorage"])
              commit('setLoaded', false);
            }
          })
          .catch(err => {
          });
      }
    },
    localStorageTest({ commit }) {
      commit('setLocalStorageData')
      // localStorage.setItem('test2', 'second test for localStorage')
    },
    retrieveLocalStorageTest() {
      let test = localStorage.getItem('test2')
    }
  },
  mutations: {
    setLoaded: (state, bool) => {
      state.loading = bool;
      state.loadResults = bool
    },
    setReadyToLoad: (state, bool) => {
      
    },
    setLoadingModal: (state, bool) => {
      state.loadingModal = bool;
    },
    setCloseInputWarningModal: (state, bool) => {
      state.inputWarningModal = bool;
    },
    setCloseLightDutyWarningModal: (state, bool) => {
      state.lightDutyWarningModal = bool;
    },
    setNewInput: (state, data) => {
      state.techMixSum -= data.diff
      // Vue.set(state.inputs, data.name, (state.inputs[data.name] -= data.diff))
      if (data.name === 'Biomass') {
        state.biomass_percent -= data.diff;
      } else if (data.name === 'Coal') {
        state.coal_percent -= data.diff;
      } else if (data.name === 'Geothermal') {
        state.geothermal_percent -= data.diff;
      } else if (data.name === 'Hydro') {
        state.hydro_percent -= data.diff;
      } else if (data.name === 'Natural Gas') {
        state.ng_percent -= data.diff;
      } else if (data.name === 'Nuclear') {
        state.nuclear_percent -= data.diff;
      } else if (data.name === 'Petroleum') {
        state.petroleum_percent -= data.diff;
      } else if (data.name === 'Solar PV') {
        state.PV_percent -= data.diff;
      } else if (data.name === 'Solar CSP') {
        state.CSP_percent -= data.diff;
      } else {
        state.wind_percent -= data.diff;
      }
    },
    setLDV: (state, data) => {
      state.ldv_driven_percent -= data.diff

      state.ldv_liquid_percent = (100 - state.ldv_driven_percent)
      state.ldvInputs['Petrol+Biofuel blend'] = 100 - state.ldv_driven_percent
    },
    setHeating: (state, data) => {
      state.heatingSum -= data.diff
      if (data.name === 'Natural Gas') {
        state.r_sh_ng -= data.diff
      } else if (data.name === 'Electricity') {
        state.r_sh_e -= data.diff
      } else {
        state.r_sh_o -= data.diff
      }
    },
    setSampleSankeyLinks: (state, data) => {
      state.sankey.links = data
    },
    setSampleSankeyNodes: (state, data) => {
      state.sankey.nodes = data;
    },
    setSankeyLinks: (state, data) => {
      data.forEach(link => {
        delete link['Product'];
        delete link['edge_id'];
        delete link['From_node_id'];
        delete link['To_node_id'];
        delete link['type'];
        if (link['From'].includes('_')) {
          let newLink = link['From'].replace(/_/g, ' ');
          link.source = newLink;
        } else {
          link.source = link['From'];
        }
        if (link['To'].includes('_')) {
          let newTarget = link['To'].replace(/_/g, ' ');
          link.target = newTarget;
        } else {
          link.target = link['To'];
        }
        link.value =link['Value'];
        delete link['From'];
        delete link['To'];
        delete link['Value'];
      });

      let final = data;

      state.sankey.links = final;
    },
    setShareSankeyLinks: (state, data) => {
      data.forEach(link => {
        delete link['Product'];
        delete link['edge_id'];
        delete link['From_node_id'];
        delete link['To_node_id'];
        delete link['type'];
        if (link['From']) {
          if (link['From'].includes('_')) {
            let newLink = link['From'].replace(/_/g, ' ');
            link.source = newLink;
          } else {
            link.source = link['From'];
          }
        }
        if (link['To']) {
          if (link['To'].includes('_')) {
            let newTarget = link['To'].replace(/_/g, ' ');
            link.target = newTarget;
          } else {
            link.target = link['To'];
          }
        }
        if (link['Value']) {
          // link.value = link['Value'].toFixed;

        }
        delete link['From'];
        delete link['To'];
        delete link['Value'];
      });

      let final = data;

      state.shareSankey.links = final;
    },
    setSankeyNodes: (state, data) => {
      data.forEach(node => {
        if (node['Node'].includes('_')) {
          let newNode = node['Node'].replace(/_/g, ' ');
          node.name = newNode;
        } else {
          node.name = node['Node'];
        }
        delete node['Node'];
        delete node['node_id'];
        delete node['type'];
      });

      let final = data;

      state.sankey.nodes = final;
    },
    setShareSankeyNodes: (state, data) => {
      data.forEach(node => {
        if (node['Node'].includes('_')) {
          let newNode = node['Node'].replace(/_/g, ' ');
          node.name = newNode;
        } else {
          node.name = node['Node'];
        }
        delete node['Node'];
        delete node['node_id'];
        delete node['type'];
      });

      let final = data;

      state.shareSankey.nodes = final;
    },
    setToggleStorage: (state) => {
      if (state.storage) {
        state.storage = false
      } else {
        state.storage = true
      }
    },
    setTimeSeriesMWOutput: (state, data) => {
      // state.timeSeries["Hourly_MW_AnnualStorage"] = data
      state.timeSeries["Hourly_MW_AnnualStorage"] = []
      let final = {};
      final.wind = [];
      final.ngcc = [];
      final.ngct = [];
      final.nuclear = [];
      final.hydro = [];
      final.coal = [];
      final.biomass = [];
      final.petroleum = [];
      final.geothermal = [];
      final.pv = [];
      final.csp = [];
      final.storageDispatched = [];
      // final.solar = [];
      data.forEach((obj, index) => {
        // let d = new Date(obj['Hour_ending'] * 3600000)
        let d = obj['Hour_ending'] * 3600000
        final.nuclear.push([d, obj['Nuclear']]);
        final.hydro.push([d, obj['Hydro']]);
        final.wind.push([d, obj['Wind_DirectToGrid']]);
        final.pv.push([d, obj['PV_DirectToGrid']]);
        final.csp.push([d, obj['CSP_DirectToGrid']]);
        final.biomass.push([d, obj['Biomass']]);
        final.coal.push([d, obj['Coal']]);
        final.geothermal.push([d, obj['Geothermal']]);
        final.ngcc.push([d, obj['NGCC']]);
        final.ngct.push([d, obj['NGCT']]);
        final.petroleum.push([d, obj['Petroleum']]);
        final.storageDispatched.push([d, obj['WindSolar_Stored_then_Dispatched']])
      });
      
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 0,
      { name: 'Hydro',
        // type: 'column',
        data: final.hydro,
        color: '#3D3BFF'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 1,
      { name: 'Wind',
        // type: 'column',
        data: final.wind,
        color: '#925E95'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 2,
      { name: 'Solar PV',
        // type: 'column',
        data: final.pv,
        color: '#FAE059'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 3,
      { name: 'Solar CSP',
        // type: 'column',
        data: final.csp,
        color: '#BCA845'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 4,
      { name: 'Biomass',
        // type: 'column',
        data: final.biomass,
        color: '#A6F2A9'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 5,
      { name: 'Coal',
        // type: 'column',
        data: final.coal,
        color: '#898989'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 6,
      { name: 'Geothermal',
        // type: 'column',
        data: final.geothermal,
        color: '#A87D4C'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 7,
      { name: 'NGCC',
        // type: 'column',
        data: final.ngcc,
        color: '#62BEF7'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 8,
      { name: 'NGCT',
        // type: 'column',
        data: final.ngct,
        color: '#AED7EF'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 9,
      { name: 'Petroleum',
        // type: 'column',
        data: final.petroleum,
        color: '#7AA37B'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 10,
      { name: 'Nuclear',
        // type: 'column',
        data: final.nuclear,
        color: '#D44148'
      })
      Vue.set(state.timeSeries["Hourly_MW_AnnualStorage"], 11,
      { name: 'Storage Dispatched',
        // type: 'column',
        data: final.storageDispatched,
        color: '#000000'
      })
      state.timeSeriesMW = state.timeSeries['Hourly_MW_AnnualStorage']
    
    },
    setTimeSeriesMWNoStorage: (state, data) => {
      // state.timeSeries["Hourly_MW_AnnualStorage"] = data
      state.timeSeries["Hourly_MW_NoStorage"] = []
      let final = {};
      final.wind = [];
      final.ngcc = [];
      final.ngct = [];
      final.nuclear = [];
      final.hydro = [];
      final.coal = [];
      final.biomass = [];
      final.petroleum = [];
      final.geothermal = [];
      final.pv = [];
      final.csp = [];
      final.windCurtailed = [];
      final.pvCurtailed = [];
      final.cspCurtailed = [];
      // final.solar = [];
      data.forEach((obj, index) => {
        // let d = new Date(obj['Hour_ending'] * 3600000)
        let d = obj['Hour_ending'] * 3600000
        final.nuclear.push([d, obj['Nuclear']]);
        final.hydro.push([d, obj['Hydro']]);
        final.wind.push([d, obj['Wind_DirectToGrid']]);
        final.pv.push([d, obj['PV_DirectToGrid']]);
        final.csp.push([d, obj['CSP_DirectToGrid']]);
        final.biomass.push([d, obj['Biomass']]);
        final.coal.push([d, obj['Coal']]);
        final.geothermal.push([d, obj['Geothermal']]);
        final.ngcc.push([d, obj['NGCC']]);
        final.ngct.push([d, obj['NGCT']]);
        final.petroleum.push([d, obj['Petroleum']]);
        final.windCurtailed.push([d, obj['Wind_curtailed']]);
        final.pvCurtailed.push([d, obj['PV_curtailed']]);
        final.cspCurtailed.push([d, obj['CSP_curtailed']]);
      });
      
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 0,
      { name: 'Wind (curtailed)',
        data: final.windCurtailed,
        color: '#925E95',
        dashStyle: "ShortDash"
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 1,
      { name: 'Solar PV (curtailed)',
        data: final.pvCurtailed,
        color: '#FAE059',
        dashStyle: "ShortDash"
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 2,
      { name: 'Solar CSP (curtailed)',
        data: final.cspCurtailed,
        color: '#BCA845',
        dashStyle: "ShortDash"
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 3,
      { name: 'Hydro',
        // type: 'column',
        data: final.hydro,
        color: '#3D3BFF'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 4,
      { name: 'Wind',
        // type: 'column',
        data: final.wind,
        color: '#925E95'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 5,
      { name: 'Solar PV',
        // type: 'column',
        data: final.pv,
        color: '#FAE059'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 6,
      { name: 'Solar CSP',
        // type: 'column',
        data: final.csp,
        color: '#BCA845'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 7,
      { name: 'Biomass',
        // type: 'column',
        data: final.biomass,
        color: '#A6F2A9'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 8,
      { name: 'Coal',
        // type: 'column',
        data: final.coal,
        color: '#898989'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 9,
      { name: 'Geothermal',
        // type: 'column',
        data: final.geothermal,
        color: '#A87D4C'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 10,
      { name: 'NGCC',
        // type: 'column',
        data: final.ngcc,
        color: '#62BEF7'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 11,
      { name: 'NGCT',
        // type: 'column',
        data: final.ngct,
        color: '#AED7EF'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 12,
      { name: 'Petroleum',
        // type: 'column',
        data: final.petroleum,
        color: '#7AA37B'
      })
      Vue.set(state.timeSeries["Hourly_MW_NoStorage"], 12,
      { name: 'Nuclear',
        // type: 'column',
        data: final.nuclear,
        color: '#D44148'
      })
      state.timeSeriesMWNoStorage = state.timeSeries['Hourly_MW_NoStorage']

    },
    setTimeSeriesGGSheet: (state, data) => {
      state.timeSeries["DollarPerYearStorage"]["pp_capex"] = []
      state.timeSeries["DollarPerYearStorage"]["t_and_d_capex"] = []
      state.timeSeries["DollarPerYearStorage"]["pp_opex"] = []
      state.timeSeries["DollarPerYearStorage"]["t_and_d_opex"] = []
      state.timeSeries["DollarPerYearStorage"]["pet_industrial"] = []
      state.timeSeries["DollarPerYearStorage"]["pet_commercial"] = []
      state.timeSeries["DollarPerYearStorage"]["pet_transport"] = []
      state.timeSeries["DollarPerYearStorage"]["pet_res"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_industrial"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_commercial"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_transport"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_res"] = []
      state.timeSeries["DollarPerYearStorage"]["coal_non_elec"] = []

      state.timeSeries["EmissionsStorage"]["Total_Emissions"] = []
      state.timeSeries["EmissionsStorage"]["Coal"] = []
      state.timeSeries["EmissionsStorage"]["Natural Gas"] = []
      state.timeSeries["EmissionsStorage"]["Petroleum"] = []
      state.timeSeries["EmissionsStorage"]["Embodied"] = []

      state.timeSeries["CapacityStorage"] = {}

      state.timeSeries["DollarPerYearStorage"]["all_pp_opex"] = []
      state.timeSeries["DollarPerYearStorage"]["all_pp_capex"] = []
      state.timeSeries["DollarPerYearStorage"]["TandD_opex"] = []
      state.timeSeries["DollarPerYearStorage"]["TandD_capex"] = []
      state.timeSeries["DollarPerYearStorage"]["oil_indus_spending"] = []
      state.timeSeries["DollarPerYearStorage"]["oil_commerce_spending"] = []
      state.timeSeries["DollarPerYearStorage"]["oil_transport_spending"] = []
      state.timeSeries["DollarPerYearStorage"]["oil_resid_spending"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_indus_spending"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_commerce_spending"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_transport_spending"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_resid_spending"] = []
      state.timeSeries["DollarPerYearStorage"]["coal_not_elec"] = []

      state.timeSeries["DollarPerYearStorage"]["all_pp_opex_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["all_pp_capex_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["TandD_opex_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["TandD_capex_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["oil_indus_spending_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["oil_commerce_spending_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["oil_transport_spending_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["oil_resid_spending_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_indus_spending_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_commerce_spending_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_transport_spending_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["ng_resid_spending_GDP"] = []
      state.timeSeries["DollarPerYearStorage"]["coal_not_elec_GDP"] = []

      //Per Year Information
      for (let point in data.opex_wfuel.all_pp[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["pp_opex"].push(Number(data.opex_wfuel.all_pp[0][point]))
        }
      }
      for (let point in data.capex.all_pp[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["pp_capex"].push(Number(data.capex.all_pp[0][point]))
        }
      }
      for (let point in data.opex.TandD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["t_and_d_opex"].push(Number(data.opex.TandD[0][point]))
        }
      }
      for (let point in data.capex.TandD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["t_and_d_capex"].push(Number(data.capex.TandD[0][point]))
        }
      }
      for (let point in data.oil_indus_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["pet_industrial"].push(Number(data.oil_indus_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.oil_commerce_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["pet_commercial"].push(Number(data.oil_commerce_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.oil_transport_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["pet_transport"].push(Number(data.oil_transport_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.oil_resid_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["pet_res"].push(Number(data.oil_resid_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.ng_indus_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_industrial"].push(Number(data.ng_indus_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.ng_commerce_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_commercial"].push(Number(data.ng_commerce_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.ng_transport_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_transport"].push(Number(data.ng_transport_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.ng_resid_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_res"].push(Number(data.ng_resid_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.coal_not_elec.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["coal_non_elec"].push(Number(data.coal_not_elec.energy_sys_BillionsUSD[0][point]))
        }
      }

      //Per Person Information
      for (let point in data.all_pp_opex.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["all_pp_opex"].push(data.all_pp_opex.USD_per_person[0][point])
        }
      }
      for (let point in data.all_pp_capex.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["all_pp_capex"].push(data.all_pp_capex.USD_per_person[0][point])
        }
      }
      for (let point in data.TandD_opex.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["TandD_opex"].push(data.TandD_opex.USD_per_person[0][point])
        }
      }
      for (let point in data.TandD_capex.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["TandD_capex"].push(data.TandD_capex.USD_per_person[0][point])
        }
      }
      for (let point in data.oil_indus_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["oil_indus_spending"].push(data.oil_indus_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.oil_commerce_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["oil_commerce_spending"].push(data.oil_commerce_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.oil_transport_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["oil_transport_spending"].push(data.oil_transport_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.oil_resid_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["oil_resid_spending"].push(data.oil_resid_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.ng_indus_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_indus_spending"].push(data.ng_indus_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.ng_commerce_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_commerce_spending"].push(data.ng_commerce_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.ng_transport_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_transport_spending"].push(data.ng_transport_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.ng_resid_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_resid_spending"].push(data.ng_resid_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.coal_not_elec.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["coal_not_elec"].push(data.coal_not_elec.USD_per_person[0][point])
        }
      }

      //GDP Information
      for (let point in data.all_pp_opex.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["all_pp_opex_GDP"].push(data.all_pp_opex.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.all_pp_capex.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["all_pp_capex_GDP"].push(data.all_pp_capex.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.TandD_opex.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["TandD_opex_GDP"].push(data.TandD_opex.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.TandD_capex.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["TandD_capex_GDP"].push(data.TandD_capex.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.oil_indus_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["oil_indus_spending_GDP"].push(data.oil_indus_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.oil_commerce_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["oil_commerce_spending_GDP"].push(data.oil_commerce_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.oil_transport_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["oil_transport_spending_GDP"].push(data.oil_transport_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.oil_resid_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["oil_resid_spending_GDP"].push(data.oil_resid_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.ng_indus_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_indus_spending_GDP"].push(data.ng_indus_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.ng_commerce_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_commerce_spending_GDP"].push(data.ng_commerce_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.ng_transport_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_transport_spending_GDP"].push(data.ng_transport_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.ng_resid_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["ng_resid_spending_GDP"].push(data.ng_resid_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.coal_not_elec.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearStorage"]["coal_not_elec_GDP"].push(data.coal_not_elec.USDperUSDofGDP_pct[0][point])
        }
      }

      //Emissions Information
      for (let point in data.emissions.all_pp[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsStorage"]["Total_Emissions"].push(Number(data.emissions.all_pp[0][point]))
        }
      }
      for (let point in data.MtCO2.coal[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsStorage"]["Coal"].push(Number(data.MtCO2.coal[0][point]))
        }
      }
      for (let point in data.MtCO2.NG[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsStorage"]["Natural Gas"].push(Number(data.MtCO2.NG[0][point]))
        }
      }
      for (let point in data.MtCO2.petroleum[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsStorage"]["Petroleum"].push(Number(data.MtCO2.petroleum[0][point]))
        }
      }
      for (let point in data.MtCO2.embodied_in_PP[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsStorage"]["Embodied"].push(Number(data.MtCO2.embodied_in_PP[0][point]))
        }
      }

      //Capacity Information
      for (let category in data.powerplantcapacity) {
        state.timeSeries["CapacityStorage"][category] = [];
        for (let point in data.powerplantcapacity[category][0]) {
          if (point !== "type" || point !== "value") {
            state.timeSeries["CapacityStorage"][category].push(Number(data.powerplantcapacity[category][0][point]))
          }
        }
      }

      //Share Modal PP Capacity Info
      for (let category in data.powerplantcapacity) {
        if (category === 'biomass') {
          state.shareModalPPCapacityStorage["Biomass"][0] = data.powerplantcapacity[category][0]["2016"];
          state.shareModalPPCapacityStorage["Biomass"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'coal') {
          state.shareModalPPCapacityStorage["Coal"][0] = data.powerplantcapacity[category][0]["2016"];
          state.shareModalPPCapacityStorage["Coal"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'geothermal') {
          state.shareModalPPCapacityStorage["Geothermal"][0] = data.powerplantcapacity[category][0]["2016"];
          state.shareModalPPCapacityStorage["Geothermal"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'hydro') {
          state.shareModalPPCapacityStorage["Hydro"][0] = data.powerplantcapacity[category][0]["2016"];
          state.shareModalPPCapacityStorage["Hydro"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'nuclear') {
          state.shareModalPPCapacityStorage["Nuclear"][0] = data.powerplantcapacity[category][0]["2016"];
          state.shareModalPPCapacityStorage["Nuclear"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'petroleum') {
          state.shareModalPPCapacityStorage["Petroleum"][0] = data.powerplantcapacity[category][0]["2016"];
          state.shareModalPPCapacityStorage["Petroleum"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'solarCSP') {
          state.shareModalPPCapacityStorage["Solar CSP"][0] = data.powerplantcapacity[category][0]["2016"];
          state.shareModalPPCapacityStorage["Solar CSP"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'solarPV') {
          state.shareModalPPCapacityStorage["Solar PV"][0] = data.powerplantcapacity[category][0]["2016"];
          state.shareModalPPCapacityStorage["Solar PV"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'wind') {
          state.shareModalPPCapacityStorage["Wind"][0] = data.powerplantcapacity[category][0]["2016"];
          state.shareModalPPCapacityStorage["Wind"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'ngcc') {
            state.shareModalPPCapacityStorage["Natural Gas"][0] = data.powerplantcapacity[category][0]["2016"];
            state.shareModalPPCapacityStorage["Natural Gas"][1] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'ngct') {
            state.shareModalPPCapacityStorage["Natural Gas"][0] += data.powerplantcapacity[category][0]["2016"];
            state.shareModalPPCapacityStorage["Natural Gas"][1] += data.powerplantcapacity[category][0]["2050"];
        }
      }

      state.ppCapStorage_2016 = data["powerplantcapacity"]["total"][0]["2016"]


      // state.capPower = data["powerplantcapacity"]["battery"][0]["2050"]
      state.ppCapStorage = data["powerplantcapacity"]["total"][0]["2050"]
      state.netGenStorage = data["generation"]["total"][0]["2050"]
      state.capPowerStorage = data["powerplantcapacity"]["battery"][0]["2050"]
      state.capEnergyStorage = data["generation"]["battery"][0]["2050"]

      // if(state.storage) {
        state.timeSeriesDollar = state.timeSeries["DollarPerYearStorage"]
        state.timeSeriesEmissions = state.timeSeries["EmissionsStorage"]
        state.timeSeriesCapacity = state.timeSeries["CapacityStorage"] 
      // }
    },
    setTimeSeriesGGSheetNoStorage: (state, data) => {
      state.timeSeries["DollarPerYearNoStorage"]["pp_capex"] = []
      state.timeSeries["DollarPerYearNoStorage"]["t_and_d_capex"] = []
      state.timeSeries["DollarPerYearNoStorage"]["pp_opex"] = []
      state.timeSeries["DollarPerYearNoStorage"]["t_and_d_opex"] = []
      state.timeSeries["DollarPerYearNoStorage"]["pet_industrial"] = []
      state.timeSeries["DollarPerYearNoStorage"]["pet_commercial"] = []
      state.timeSeries["DollarPerYearNoStorage"]["pet_transport"] = []
      state.timeSeries["DollarPerYearNoStorage"]["pet_res"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_industrial"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_commercial"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_transport"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_res"] = []
      state.timeSeries["DollarPerYearNoStorage"]["coal_non_elec"] = []

      state.timeSeries["EmissionsNoStorage"]["Total_Emissions"] = []
      state.timeSeries["EmissionsNoStorage"]["Coal"] = []
      state.timeSeries["EmissionsNoStorage"]["Natural Gas"] = []
      state.timeSeries["EmissionsNoStorage"]["Petroleum"] = []
      state.timeSeries["EmissionsNoStorage"]["Embodied"] = []

      state.timeSeries["CapacityNoStorage"] = {}

      state.timeSeries["DollarPerYearNoStorage"]["all_pp_opex"] = []
      state.timeSeries["DollarPerYearNoStorage"]["all_pp_capex"] = []
      state.timeSeries["DollarPerYearNoStorage"]["TandD_opex"] = []
      state.timeSeries["DollarPerYearNoStorage"]["TandD_capex"] = []
      state.timeSeries["DollarPerYearNoStorage"]["oil_indus_spending"] = []
      state.timeSeries["DollarPerYearNoStorage"]["oil_commerce_spending"] = []
      state.timeSeries["DollarPerYearNoStorage"]["oil_transport_spending"] = []
      state.timeSeries["DollarPerYearNoStorage"]["oil_resid_spending"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_indus_spending"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_commerce_spending"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_transport_spending"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_resid_spending"] = []
      state.timeSeries["DollarPerYearNoStorage"]["coal_not_elec"] = []

      state.timeSeries["DollarPerYearNoStorage"]["all_pp_opex_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["all_pp_capex_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["TandD_opex_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["TandD_capex_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["oil_indus_spending_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["oil_commerce_spending_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["oil_transport_spending_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["oil_resid_spending_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_indus_spending_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_commerce_spending_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_transport_spending_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["ng_resid_spending_GDP"] = []
      state.timeSeries["DollarPerYearNoStorage"]["coal_not_elec_GDP"] = []

      //Per Year Information
      for (let point in data.opex_wfuel.all_pp[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["pp_opex"].push(Number(data.opex_wfuel.all_pp[0][point]))
        }
      }
      for (let point in data.capex.all_pp[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["pp_capex"].push(Number(data.capex.all_pp[0][point]))
        }
      }
      for (let point in data.opex.TandD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["t_and_d_opex"].push(Number(data.opex.TandD[0][point]))
        }
      }
      for (let point in data.capex.TandD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["t_and_d_capex"].push(Number(data.capex.TandD[0][point]))
        }
      }
      for (let point in data.oil_indus_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["pet_industrial"].push(Number(data.oil_indus_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.oil_commerce_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["pet_commercial"].push(Number(data.oil_commerce_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.oil_transport_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["pet_transport"].push(Number(data.oil_transport_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.oil_resid_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["pet_res"].push(Number(data.oil_resid_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.ng_indus_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_industrial"].push(Number(data.ng_indus_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.ng_commerce_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_commercial"].push(Number(data.ng_commerce_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.ng_transport_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_transport"].push(Number(data.ng_transport_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.ng_resid_spending.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_res"].push(Number(data.ng_resid_spending.energy_sys_BillionsUSD[0][point]))
        }
      }
      for (let point in data.coal_not_elec.energy_sys_BillionsUSD[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["coal_non_elec"].push(Number(data.coal_not_elec.energy_sys_BillionsUSD[0][point]))
        }
      }

      //Per Person Information
      for (let point in data.all_pp_opex.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["all_pp_opex"].push(data.all_pp_opex.USD_per_person[0][point])
        }
      }
      for (let point in data.all_pp_capex.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["all_pp_capex"].push(data.all_pp_capex.USD_per_person[0][point])
        }
      }
      for (let point in data.TandD_opex.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["TandD_opex"].push(data.TandD_opex.USD_per_person[0][point])
        }
      }
      for (let point in data.TandD_capex.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["TandD_capex"].push(data.TandD_capex.USD_per_person[0][point])
        }
      }
      for (let point in data.oil_indus_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["oil_indus_spending"].push(data.oil_indus_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.oil_commerce_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["oil_commerce_spending"].push(data.oil_commerce_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.oil_transport_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["oil_transport_spending"].push(data.oil_transport_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.oil_resid_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["oil_resid_spending"].push(data.oil_resid_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.ng_indus_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_indus_spending"].push(data.ng_indus_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.ng_commerce_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_commerce_spending"].push(data.ng_commerce_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.ng_transport_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_transport_spending"].push(data.ng_transport_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.ng_resid_spending.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_resid_spending"].push(data.ng_resid_spending.USD_per_person[0][point])
        }
      }
      for (let point in data.coal_not_elec.USD_per_person[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["coal_not_elec"].push(data.coal_not_elec.USD_per_person[0][point])
        }
      }

      //GDP Information
      for (let point in data.all_pp_opex.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["all_pp_opex_GDP"].push(data.all_pp_opex.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.all_pp_capex.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["all_pp_capex_GDP"].push(data.all_pp_capex.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.TandD_opex.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["TandD_opex_GDP"].push(data.TandD_opex.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.TandD_capex.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["TandD_capex_GDP"].push(data.TandD_capex.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.oil_indus_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["oil_indus_spending_GDP"].push(data.oil_indus_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.oil_commerce_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["oil_commerce_spending_GDP"].push(data.oil_commerce_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.oil_transport_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["oil_transport_spending_GDP"].push(data.oil_transport_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.oil_resid_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["oil_resid_spending_GDP"].push(data.oil_resid_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.ng_indus_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_indus_spending_GDP"].push(data.ng_indus_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.ng_commerce_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_commerce_spending_GDP"].push(data.ng_commerce_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.ng_transport_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_transport_spending_GDP"].push(data.ng_transport_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.ng_resid_spending.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["ng_resid_spending_GDP"].push(data.ng_resid_spending.USDperUSDofGDP_pct[0][point])
        }
      }
      for (let point in data.coal_not_elec.USDperUSDofGDP_pct[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["DollarPerYearNoStorage"]["coal_not_elec_GDP"].push(data.coal_not_elec.USDperUSDofGDP_pct[0][point])
        }
      }

      //Emissions Information
      for (let point in data.emissions.all_pp[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsNoStorage"]["Total_Emissions"].push(Number(data.emissions.all_pp[0][point]))
        }
      }
      for (let point in data.MtCO2.coal[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsNoStorage"]["Coal"].push(Number(data.MtCO2.coal[0][point]))
        }
      }
      for (let point in data.MtCO2.NG[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsNoStorage"]["Natural Gas"].push(Number(data.MtCO2.NG[0][point]))
        }
      }
      for (let point in data.MtCO2.petroleum[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsNoStorage"]["Petroleum"].push(Number(data.MtCO2.petroleum[0][point]))
        }
      }
      for (let point in data.MtCO2.embodied_in_PP[0]) {
        if (point !== "type" || point !== "value") {
          state.timeSeries["EmissionsNoStorage"]["Embodied"].push(Number(data.MtCO2.embodied_in_PP[0][point]))
        }
      }

      //Capacity Information
      for (let category in data.powerplantcapacity) {
        state.timeSeries["CapacityNoStorage"][category] = [];
        for (let point in data.powerplantcapacity[category][0]) {
          if (point !== "type" || point !== "value") {
            state.timeSeries["CapacityNoStorage"][category].push(Number(data.powerplantcapacity[category][0][point]))
          }
        }
      }

      //Share Modal PP Capacity Information
      for (let category in data.powerplantcapacity) {
        if (category === 'biomass') {
          state.shareModalPPCapacityNoStorage["Biomass"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'coal') {
          state.shareModalPPCapacityNoStorage["Coal"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'geothermal') {
          state.shareModalPPCapacityNoStorage["Geothermal"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'hydro') {
          state.shareModalPPCapacityNoStorage["Hydro"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'nuclear') {
          state.shareModalPPCapacityNoStorage["Nuclear"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'petroleum') {
          state.shareModalPPCapacityNoStorage["Petroleum"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'solarCSP') {
          state.shareModalPPCapacityNoStorage["Solar CSP"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'solarPV') {
          state.shareModalPPCapacityNoStorage["Solar PV"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'wind') {
          state.shareModalPPCapacityNoStorage["Wind"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'ngcc') {
          // if (state.shareModalPPCapacityNoStorage["Natural Gas"].length) {

          //   state.shareModalPPCapacityNoStorage["Natural Gas"][0] += data.powerplantcapacity[category][0]["2050"];
          // } else {
          state.shareModalPPCapacityNoStorage["Natural Gas"][0] = data.powerplantcapacity[category][0]["2050"];
        } else if (category === 'ngct') {
          state.shareModalPPCapacityNoStorage["Natural Gas"][0] += data.powerplantcapacity[category][0]["2050"];
        }
      }
      state.ppCapNoStorage = data["powerplantcapacity"]["total"][0]["2050"]
      state.netGenNoStorage = data["generation"]["total"][0]["2050"]
      state.capPowerNoStorage = data["powerplantcapacity"]["battery"][0]["2050"]
      state.capEnergyNoStorage = data["generation"]["battery"][0]["2050"]

      // if(!state.storage) {
        state.timeSeriesDollarNoStorage = state.timeSeries["DollarPerYearNoStorage"]
        state.timeSeriesEmissionsNoStorage = state.timeSeries["EmissionsNoStorage"]
        state.timeSeriesCapacityNoStorage = state.timeSeries["CapacityNoStorage"]
      // }
    },
    setSummaryChartStorage: (state, data, modalData) => {
      state["summaryChartStorage"] = {
        'Natural Gas': [],
        'Geothermal': [],
        'Nuclear': [],
        'Petroleum': [],
        'Hydro': [],
        'Biomass': [],
        'Wind': [],
        'Solar PV': [],
        'Solar CSP': [],
        'Coal': []
      }
      state.warningModal  = {}
      data.forEach((obj) => {
        if (obj["Technology"] === "Biomass") {
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModal["Biomass"] = {input: state.biomass_percent, actual: obj["Pct_MWhActual"]}
          }
          state["summaryChartStorage"]["Biomass"].push(obj["Fraction_MWhActual"] * 100)
          state.bioGenStorage = obj["TWhGeneration"]
        } else if (obj["Technology"] === "Coal") {
          // if (obj["Pct_MWh_flag"] === 0) {
          //   state.warningModal["Coal"] = {input: state.coal_percent, actual: obj["Pct_MWhActual"]}
          // }
          state["summaryChartStorage"]["Coal"].push(obj["Fraction_MWhActual"] * 100)
          state.coalGenStorage = obj["TWhGeneration"];
        } else if (obj["Technology"] === "Geothermal") {
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModal["Geothermal"] = {input: state.geothermal_percent, actual: obj["Pct_MWhActual"]}
          }
          state["summaryChartStorage"]["Geothermal"].push(obj["Fraction_MWhActual"] * 100)
          state.geoGenStorage = obj["TWhGeneration"]
        } else if (obj["Technology"] === "CSP") {
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModal["Solar CSP"] = {input: state.CSP_percent, actual: obj["Pct_MWhActual"]}
          }
          state["summaryChartStorage"]["Solar CSP"].push(obj["Fraction_MWhActual"] * 100)
          state.cspGenStorage = obj["TWhGeneration"]
        } else if (obj["Technology"] === "HydroDispatch") {
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModal["Hydro"] = {input: state.hydro_percent, actual: obj["Pct_MWhActual"]}
          }
          state["summaryChartStorage"]["Hydro"].push(obj["Fraction_MWhActual"] * 100)
          state.hydroGenStorage = obj["TWhGeneration"]
        } else if (obj["Technology"] === "Nuclear") {
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModal["Nuclear"] = {input: state.nuclear_percent, actual: obj["Pct_MWhActual"]}
          }
          state["summaryChartStorage"]["Nuclear"].push(obj["Fraction_MWhActual"] * 100)
          state.nuclearGenStorage = obj["TWhGeneration"]
        } else if (obj["Technology"] === "PetroleumCC") {
          // if (obj["Pct_MWh_flag"] === 0) {
          //   state.warningModal["Petroleum"] = {input: state.nuclear_percent, actual: obj["Pct_MWhActual"]}
          // }
          state["summaryChartStorage"]["Petroleum"].push(obj["Fraction_MWhActual"] * 100)
          state.petGenStorage = obj["TWhGeneration"]
        } else if (obj["Technology"] === "PV") {
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModal["Solar PV"] = {input: state.PV_percent, actual: obj["Pct_MWhActual"]}
          }
          state["summaryChartStorage"]["Solar PV"].push(obj["Fraction_MWhActual"] * 100)
          state.pvGenStorage = obj["TWhGeneration"]
        } else if (obj["Technology"] === "Wind") {
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModal["Wind"] = {input: state.wind_percent, actual: obj["Pct_MWhActual"]}
          }
          state["summaryChartStorage"]["Wind"].push(obj["Fraction_MWhActual"] * 100)
          state.windGenStorage = obj["TWhGeneration"]
        } else if (obj["Technology"] === "NGCC") {
          //ASK CAREY ABOUT THE TWO NATURAL GAS INPUTS FOR THE POP UP
          if (!state["summaryChartStorage"]["Natural Gas"][0]) {
            state["summaryChartStorage"]["Natural Gas"].push(obj["Fraction_MWhActual"] * 100)
            state.ngGenStorage = obj["TWhGeneration"]
          } else  {
            state["summaryChartStorage"]["Natural Gas"][0] += obj["Fraction_MWhActual"] * 100
            state.ngGenStorage += obj["TWhGeneration"]
          }
        } else if (obj["Technology"] === "NGCT") {
          if (!state["summaryChartStorage"]["Natural Gas"][0]) {
            state["summaryChartStorage"]["Natural Gas"].push(obj["Fraction_MWhActual"] * 100)
            state.ngGenStorage = obj["TWhGeneration"]
          } else  {
            state["summaryChartStorage"]["Natural Gas"][0] += obj["Fraction_MWhActual"] * 100
            state.ngGenStorage += obj["TWhGeneration"]
          }
        } else if (obj["Technology"] === "LandTotal") {
          state.landUseStorage = obj["Land_1000acres"];
          state.landUsePercentStorage = obj["PctLand"];
          state.landUseStorageDirect = obj["Land_1000acres_direct"];
          state.landUsePercentStorageDirect = obj["PctLandDirect"]
        } else if (obj["Technology"] === "Total") {
          state.totalGenStorage = obj["TWhGeneration"]
        }

      })
      if (Object.keys(state.warningModal).length > 0) {
        state.inputWarningModal = true;
        state.inputWarningShareReport = true;
      }
      if (state.ldv_driven_percent > 20) {
        state.lightDutyWarningModal = true
      }
    },
    setSummaryChartNoStorage: (state, data) => {
      Vue.delete(state["summaryChartNoStorage"]["Biomass"], 0)
      Vue.delete(state["summaryChartNoStorage"]["Coal"], 0)
      Vue.delete(state["summaryChartNoStorage"]["Geothermal"], 0)
      Vue.delete(state["summaryChartNoStorage"]["Solar CSP"], 0)
      Vue.delete(state["summaryChartNoStorage"]["Hydro"], 0)
      Vue.delete(state["summaryChartNoStorage"]["Nuclear"], 0)
      Vue.delete(state["summaryChartNoStorage"]["Petroleum"], 0)
      Vue.delete(state["summaryChartNoStorage"]["Solar PV"], 0)
      Vue.delete(state["summaryChartNoStorage"]["Wind"], 0)
      Vue.delete(state["summaryChartNoStorage"]["Natural Gas"], 0)
      data.forEach((obj) => {
        if (obj["Technology"] === "Biomass") {
          Vue.set(state["summaryChartNoStorage"]["Biomass"], 0, obj["Fraction_MWhActual"] * 100)
          state.bioGenNoStorage = obj["TWhGeneration"]
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModalNoStorage["Biomass"] = {input: state.biomass_percent, actual: obj["Pct_MWhActual"]}
          }
        } else if (obj["Technology"] === "Coal") {
          Vue.set(state["summaryChartNoStorage"]["Coal"], 0, obj["Fraction_MWhActual"] * 100)
          state.coalGenNoStorage = obj["TWhGeneration"]
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModalNoStorage["Coal"] = {input: state.coal_percent, actual: obj["Pct_MWhActual"]}
          }
        } else if (obj["Technology"] === "Geothermal") {
          Vue.set(state["summaryChartNoStorage"]["Geothermal"], 0, obj["Fraction_MWhActual"] * 100)
          state.geoGenNoStorage = obj["TWhGeneration"]
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModalNoStorage["Geothermal"] = {input: state.geothermal_percent, actual: obj["Pct_MWhActual"]}
          }
        } else if (obj["Technology"] === "CSP") {
          Vue.set(state["summaryChartNoStorage"]["Solar CSP"], 0, obj["Fraction_MWhActual"] * 100)
          state.cspGenNoStorage = obj["TWhGeneration"]
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModalNoStorage["Solar CSP"] = {input: state.CSP_percent, actual: obj["Pct_MWhActual"]}
          }
        } else if (obj["Technology"] === "HydroDispatch") {
          Vue.set(state["summaryChartNoStorage"]["Hydro"], 0, obj["Fraction_MWhActual"] * 100)
          state.hydroGenNoStorage = obj["TWhGeneration"]
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModalNoStorage["Hydro"] = {input: state.hydro_percent, actual: obj["Pct_MWhActual"]}
          }
        } else if (obj["Technology"] === "Nuclear") {
          Vue.set(state["summaryChartNoStorage"]["Nuclear"], 0, obj["Fraction_MWhActual"] * 100)
          state.nuclearGenNoStorage = obj["TWhGeneration"]
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModalNoStorage["Nuclear"] = {input: state.nuclear_percent, actual: obj["Pct_MWhActual"]}
          }
        } else if (obj["Technology"] === "PetroleumCC") {
          Vue.set(state["summaryChartNoStorage"]["Petroleum"], 0, obj["Fraction_MWhActual"] * 100)
          state.petGenNoStorage = obj["TWhGeneration"]
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModalNoStorage["Petroleum"] = {input: state.nuclear_percent, actual: obj["Pct_MWhActual"]}
          }
        } else if (obj["Technology"] === "PV") {
          state.pvGenNoStorage = obj["TWhGeneration"]
          Vue.set(state["summaryChartNoStorage"]["Solar PV"], 0, obj["Fraction_MWhActual"] * 100)
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModalNoStorage["Solar PV"] = {input: state.PV_percent, actual: obj["Pct_MWhActual"]}
          }
        } else if (obj["Technology"] === "Wind") {
          Vue.set(state["summaryChartNoStorage"]["Wind"], 0, obj["Fraction_MWhActual"] * 100)
          state.windGenNoStorage = obj["TWhGeneration"]
          if (obj["Pct_MWh_flag"] === 0) {
            state.warningModalNoStorage["Wind"] = {input: state.wind_percent, actual: obj["Pct_MWhActual"]}
          }
        } else if (obj["Technology"] === "NGCC") {
          if (state["summaryChartNoStorage"]["Natural Gas"].length === 0) {
            Vue.set(state["summaryChartNoStorage"]["Natural Gas"], 0, obj["Fraction_MWhActual"] * 100)
            state.ngGenNoStorage = obj["TWhGeneration"]
          } else  {
            Vue.set(
              state["summaryChartNoStorage"]["Natural Gas"], 
              0, 
              state["summaryChartNoStorage"]["Natural Gas"][0] += (obj["Fraction_MWhActual"] * 100)
            )
            state.ngGenNoStorage += obj["TWhGeneration"]
          }
        } else if (obj["Technology"] === "NGCT") {
          if (state["summaryChartNoStorage"]["Natural Gas"].length === 0) {
            Vue.set(state["summaryChartNoStorage"]["Natural Gas"], 0, obj["Fraction_MWhActual"] * 100)
            state.ngGenNoStorage = obj["TWhGeneration"]
          } else  {
            Vue.set(
              state["summaryChartNoStorage"]["Natural Gas"], 
              0, 
              state["summaryChartNoStorage"]["Natural Gas"][0] += (obj["Fraction_MWhActual"] * 100)
            )
            state.ngGenNoStorage += obj["TWhGeneration"]
          }
        } else if (obj["Technology"] === "LandTotal") {
          state.landUseNoStorage = obj["Land_1000acres"];
          state.landUsePercentNoStorage = obj["PctLand"];
          state.landUseNoStorageDirect = obj["Land_1000acres_direct"];
          state.landUsePercentNoStorageDirect = obj["PctLandDirect"]          
        } else if (obj["Technology"] === "Total") {
          state.totalGenNoStorage = obj["TWhGeneration"]
        }
      })
    },
    setSummaryChartInputs: (state, data) => {
      Vue.delete(state["summaryChartInputs"]["Biomass"], 0)
      Vue.delete(state["summaryChartInputs"]["Coal"], 0)
      Vue.delete(state["summaryChartInputs"]["Geothermal"], 0)
      Vue.delete(state["summaryChartInputs"]["Solar CSP"], 0)
      Vue.delete(state["summaryChartInputs"]["Hydro"], 0)
      Vue.delete(state["summaryChartInputs"]["Nuclear"], 0)
      Vue.delete(state["summaryChartInputs"]["Petroleum"], 0)
      Vue.delete(state["summaryChartInputs"]["Solar PV"], 0)
      Vue.delete(state["summaryChartInputs"]["Wind"], 0)
      Vue.delete(state["summaryChartInputs"]["Natural Gas"], 0)
      data.forEach((obj) => {
        if (obj["_row"] === "coal_percent") {
          Vue.set(state["summaryChartInputs"]["Coal"], 0, obj["web_inputs"])
        } else if (obj["_row"] === "PV_percent") {
          Vue.set(state["summaryChartInputs"]["Solar PV"], 0, obj["web_inputs"])
        } else if (obj["_row"] === "CSP_percent") {
          Vue.set(state["summaryChartInputs"]["Solar CSP"], 0, obj["web_inputs"])
        } else if (obj["_row"] === "wind_percent") {
          Vue.set(state["summaryChartInputs"]["Wind"], 0, obj["web_inputs"])
        } else if (obj["_row"] === "biomass_percent") {
          Vue.set(state["summaryChartInputs"]["Biomass"], 0, obj["web_inputs"])
        } else if (obj["_row"] === "hydro_percent") {
          Vue.set(state["summaryChartInputs"]["Hydro"], 0, obj["web_inputs"])
        } else if (obj["_row"] === "petroleum_percent") {
          Vue.set(state["summaryChartInputs"]["Petroleum"], 0, obj["web_inputs"])
        } else if (obj["_row"] === "nuclear_percent") {
          Vue.set(state["summaryChartInputs"]["Nuclear"], 0, obj["web_inputs"])
        } else if (obj["_row"] === "geothermal_percent") {
          Vue.set(state["summaryChartInputs"]["Geothermal"], 0, obj["web_inputs"])
        } else if (obj["_row"] === "ng_percent") {
          Vue.set(state["summaryChartInputs"]["Natural Gas"], 0, obj["web_inputs"])
        }
      })
    },
    setElectricityCosts: (state, data) => {
      data.forEach((obj) => {
        if (obj["data_type"] === "cents_kwh_total") {
          state.totalElecCostStorage = obj["AnnualStorage"]
          state.totalElecCostNoStorage = obj["NoStorage"]
        } else if (obj["data_type"] === "cents_kwh_depreciation_interest") {
          state.capitalElecCostStorage = obj["AnnualStorage"]
          state.capitalElecCostNoStorage = obj["NoStorage"]
        } else if (obj["data_type"] === "cents_kwh_opex") {
          state.operatingElecCostStorage = obj["AnnualStorage"]
          state.operatingElecCostNoStorage= obj["NoStorage"]
        } else if (obj["data_type"] === "dollars_per_customer") {
          state.elecCostPerCustomerStorage = obj["AnnualStorage"]
          state.elecCostPerCustomerNoStorage= obj["NoStorage"]
        } else if (obj["data_type"] === "dollars_per_person") {
          state.elecCostPerPersonStorage = obj["AnnualStorage"]
          state.elecCostPerPersonNoStorage= obj["NoStorage"]
        } 
      })
    },
    setNewRegion: (state, id) => {
      state.region_id = id;
        if (id === 1) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 38;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 38;
          state.heatingInputs["Natural Gas"].value = 48;
          state.heatingInputs["Electricity"].value = 14;
          Vue.set(state.inputs, 'Natural Gas', 19)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 5)
          Vue.set(state.inputs, 'Petroleum', 1)
          Vue.set(state.inputs, 'Hydro', 53)
          Vue.set(state.inputs, 'Biomass', 1)
          Vue.set(state.inputs, 'Wind', 19)
          Vue.set(state.inputs, 'Solar PV', 0)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal', 2)
          state.ldvInputs['Electricity'] = 2
          state.ldvInputs['Petrol+Biofuel blend'] = 98
          state.sankeyRegion = region_1_sankey;
        } else if (id === 2) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 27;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 27;
          state.heatingInputs["Natural Gas"].value = 71;
          state.heatingInputs["Electricity"].value = 2;
          Vue.set(state.inputs, 'Natural Gas', 38)
          Vue.set(state.inputs, 'Geothermal', 4)
          Vue.set(state.inputs, 'Nuclear', 5)
          Vue.set(state.inputs, 'Petroleum', 1)
          Vue.set(state.inputs, 'Hydro', 8)
          Vue.set(state.inputs, 'Biomass', 1)
          Vue.set(state.inputs, 'Wind', 10)
          Vue.set(state.inputs, 'Solar PV', 30)
          Vue.set(state.inputs, 'Solar CSP', 3)
          Vue.set(state.inputs, 'Coal', 0)
          state.ldvInputs['Electricity'] = 14
          state.ldvInputs['Petrol+Biofuel blend'] = 86
          state.sankeyRegion = region_2_sankey;
        } else if (id === 3) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 22;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 22;
          state.heatingInputs["Natural Gas"].value = 75;
          state.heatingInputs["Electricity"].value = 3;
          Vue.set(state.inputs, 'Natural Gas', 35)
          Vue.set(state.inputs, 'Geothermal', 1)
          Vue.set(state.inputs, 'Nuclear', 0)
          Vue.set(state.inputs, 'Petroleum', 1)
          Vue.set(state.inputs, 'Hydro', 5)
          Vue.set(state.inputs, 'Biomass', 0)
          Vue.set(state.inputs, 'Wind', 7)
          Vue.set(state.inputs, 'Solar PV', 3)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal',48)
          state.ldvInputs['Electricity'] = 19
          state.ldvInputs['Petrol+Biofuel blend'] = 81
          state.sankeyRegion = region_3_sankey;
        } else if (id === 4) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 25;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 25;
          state.heatingInputs["Natural Gas"].value = 53;
          state.heatingInputs["Electricity"].value = 22;
          Vue.set(state.inputs, 'Natural Gas', 35)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 29)
          Vue.set(state.inputs, 'Petroleum', 1)
          Vue.set(state.inputs, 'Hydro', 2)
          Vue.set(state.inputs, 'Biomass', 0)
          Vue.set(state.inputs, 'Wind', 2)
          Vue.set(state.inputs, 'Solar PV', 4)
          Vue.set(state.inputs, 'Solar CSP', 1)
          Vue.set(state.inputs, 'Coal', 26)
          state.ldvInputs['Electricity'] = 3
          state.ldvInputs['Petrol+Biofuel blend'] = 97
          state.sankeyRegion = region_4_sankey;
        } else if (id === 5) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 28;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 28;
          state.heatingInputs["Natural Gas"].value = 63;
          state.heatingInputs["Electricity"].value = 9;
          Vue.set(state.inputs, 'Natural Gas', 22)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 2)
          Vue.set(state.inputs, 'Petroleum', 0)
          Vue.set(state.inputs, 'Hydro', 2)
          Vue.set(state.inputs, 'Biomass', 0)
          Vue.set(state.inputs, 'Wind', 23)
          Vue.set(state.inputs, 'Solar PV', 1)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal', 50)
          state.ldvInputs['Electricity'] = 10
          state.ldvInputs['Petrol+Biofuel blend'] = 90
          state.sankeyRegion = region_5_sankey;
        } else if (id === 6) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 29;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 29;
          state.heatingInputs["Natural Gas"].value = 58;
          state.heatingInputs["Electricity"].value = 13;
          Vue.set(state.inputs, 'Natural Gas', 53)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 8)
          Vue.set(state.inputs, 'Petroleum', 0)
          Vue.set(state.inputs, 'Hydro', 0)
          Vue.set(state.inputs, 'Biomass', 0)
          Vue.set(state.inputs, 'Wind', 10)
          Vue.set(state.inputs, 'Solar PV', 5)
          Vue.set(state.inputs, 'Solar CSP', 1)
          Vue.set(state.inputs, 'Coal', 23)
          state.ldvInputs['Electricity'] = 13
          state.ldvInputs['Petrol+Biofuel blend'] = 87
          state.sankeyRegion = region_6_sankey;
          state.sankeyRegion = null;
        } else if (id === 7) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 24;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 24;
          state.heatingInputs["Natural Gas"].value = 72;
          state.heatingInputs["Electricity"].value = 4;
          Vue.set(state.inputs, 'Natural Gas', 27)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 21)
          Vue.set(state.inputs, 'Petroleum', 0)
          Vue.set(state.inputs, 'Hydro', 0)
          Vue.set(state.inputs, 'Biomass', 0)
          Vue.set(state.inputs, 'Wind', 6)
          Vue.set(state.inputs, 'Solar PV', 2)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal', 44)
          state.ldvInputs['Electricity'] = 15
          state.ldvInputs['Petrol+Biofuel blend'] = 85
          state.sankeyRegion = region_7_sankey;
          // state.sankeyRegion = null;
        } else if (id === 8) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 40;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 40;
          state.heatingInputs["Natural Gas"].value = 47;
          state.heatingInputs["Electricity"].value = 13;
          Vue.set(state.inputs, 'Natural Gas', 59)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 18)
          Vue.set(state.inputs, 'Petroleum', 0)
          Vue.set(state.inputs, 'Hydro', 1)
          Vue.set(state.inputs, 'Biomass', 1)
          Vue.set(state.inputs, 'Wind', 0)
          Vue.set(state.inputs, 'Solar PV', 1)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal', 20)
          state.ldvInputs['Electricity'] = 5
          state.ldvInputs['Petrol+Biofuel blend'] = 95
          state.sankeyRegion = region_8_sankey;
        } else if (id === 9) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 38;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 38;
          state.heatingInputs["Natural Gas"].value = 50;
          state.heatingInputs["Electricity"].value = 12;
          Vue.set(state.inputs, 'Natural Gas', 35)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 24)
          Vue.set(state.inputs, 'Petroleum', 0)
          Vue.set(state.inputs, 'Hydro', 1)
          Vue.set(state.inputs, 'Biomass', 0)
          Vue.set(state.inputs, 'Wind', 3)
          Vue.set(state.inputs, 'Solar PV', 2)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal', 35)
          state.ldvInputs['Electricity'] = 35
          state.ldvInputs['Petrol+Biofuel blend'] = 65
          state.sankeyRegion = region_9_sankey;
        } else if (id === 10) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 41;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 41;
          state.heatingInputs["Natural Gas"].value = 41;
          state.heatingInputs["Electricity"].value = 18;
          Vue.set(state.inputs, 'Natural Gas', 29)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 37)
          Vue.set(state.inputs, 'Petroleum', 0)
          Vue.set(state.inputs, 'Hydro', 1)
          Vue.set(state.inputs, 'Biomass', 1)
          Vue.set(state.inputs, 'Wind', 2)
          Vue.set(state.inputs, 'Solar PV', 11)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal', 19)
          state.ldvInputs['Electricity'] = 8
          state.ldvInputs['Petrol+Biofuel blend'] = 92
          state.sankeyRegion = region_10_sankey;
        } else if (id === 11) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 63;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 63;
          state.heatingInputs["Natural Gas"].value = 8;
          state.heatingInputs["Electricity"].value = 29;
          Vue.set(state.inputs, 'Natural Gas', 66)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 18)
          Vue.set(state.inputs, 'Petroleum', 0)
          Vue.set(state.inputs, 'Hydro', 0)
          Vue.set(state.inputs, 'Biomass', 0)
          Vue.set(state.inputs, 'Wind', 0)
          Vue.set(state.inputs, 'Solar PV', 1)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal', 15)
          state.ldvInputs['Electricity'] = 4
          state.ldvInputs['Petrol+Biofuel blend'] = 96
          state.sankeyRegion = region_11_sankey;
        } else if (id === 12) {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 37;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 37;
          state.heatingInputs["Natural Gas"].value = 61;
          state.heatingInputs["Electricity"].value = 2;
          Vue.set(state.inputs, 'Natural Gas', 57)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 29)
          Vue.set(state.inputs, 'Petroleum', 0)
          Vue.set(state.inputs, 'Hydro', 9)
          Vue.set(state.inputs, 'Biomass', 0)
          Vue.set(state.inputs, 'Wind', 2)
          Vue.set(state.inputs, 'Solar PV', 1)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal', 2)
          state.ldvInputs['Electricity'] = 64
          state.ldvInputs['Petrol+Biofuel blend'] = 36
          state.sankeyRegion = region_12_sankey;
        } else {
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].max = 77;
          state.heatingInputs["Other (e.g. Biomass, Petrol)"].value = 77;
          state.heatingInputs["Natural Gas"].value = 22;
          state.heatingInputs["Electricity"].value = 1;
          Vue.set(state.inputs, 'Natural Gas', 47)
          Vue.set(state.inputs, 'Geothermal', 0)
          Vue.set(state.inputs, 'Nuclear', 40)
          Vue.set(state.inputs, 'Petroleum', 0)
          Vue.set(state.inputs, 'Hydro', 3)
          Vue.set(state.inputs, 'Biomass', 3)
          Vue.set(state.inputs, 'Wind', 5)
          Vue.set(state.inputs, 'Solar PV', 2)
          Vue.set(state.inputs, 'Solar CSP', 0)
          Vue.set(state.inputs, 'Coal', 0)
          state.ldvInputs['Electricity'] = 24
          state.ldvInputs['Petrol+Biofuel blend'] = 76
          state.sankeyRegion = region_13_sankey;
        }
      // } else {
    },
    loadStoredRegion: (state, payload, id) => {
      if (id === 1) {
        state.heatingInputs.Other.max = 38;
      } else if (id === 2) {
        state.heatingInputs.Other.max = 27;
      } else if (id === 3) {
        state.heatingInputs.Other.max = 22;
      } else if (id === 4) {
        state.heatingInputs.Other.max = 25;
      } else if (id === 5) {
        state.heatingInputs.Other.max = 28;
      } else if (id === 6) {
        state.heatingInputs.Other.max = 29;
      } else if (id === 7) {
        state.heatingInputs.Other.max = 24;
      } else if (id === 8) {
        state.heatingInputs.Other.max = 40;
      } else if (id === 9) {
        state.heatingInputs.Other.max = 38;
      } else if (id === 10) {
        state.heatingInputs.Other.max = 41;
      } else if (id === 11) {
        state.heatingInputs.Other.max = 63;
      } else if (id === 12) {
        state.heatingInputs.Other.max = 37;
      } else {
        state.heatingInputs.Other.max = 77;
      }
      Vue.set(state.inputs, 'Natural Gas', payload['Natural Gas'])
      Vue.set(state.inputs, 'Geothermal', payload['Geothermal'])
      Vue.set(state.inputs, 'Nuclear', payload['Nuclear'])
      Vue.set(state.inputs, 'Petroleum', payload['Petroleum'])
      Vue.set(state.inputs, 'Hydro', payload['Hydro'])
      Vue.set(state.inputs, 'Biomass', payload['Biomass'])
      Vue.set(state.inputs, 'Wind', payload['Wind'])
      Vue.set(state.inputs, 'Solar PV', payload['Solar PV'])
      Vue.set(state.inputs, 'Solar CSP', payload['Solar CSP'])
      Vue.set(state.inputs, 'Coal', payload['Coal'])
      Vue.set(state.heatingInputs['Other (e.g. Biomass, Petrol)'], 'value', payload['Heathing Other'])
      Vue.set(state.heatingInputs['Natural Gas'], 'value', payload['Heating NG'])
      Vue.set(state.heatingInputs['Electricity'], 'value', payload['Heating Elec'])
    
      state.heatingSum = 100;
    },
    setEnergySummary: (state, data) => {
      state.pimaryEnergySummary = {}

      data.forEach((obj) => {
        state.pimaryEnergySummary[obj["Fuel"]] = {
          '2016_quads': obj["2016_quads"],
          '2050_quads': obj["2050_quads"],
          '2016_quads_pct': obj["2016_quads_pct"],
          '2050_quads_pct': obj["2050_quads_pct"],
          '2016_Elec_TWh': obj["2016_Elec_TWh"],
          '2016_Elec_TWh_pct': obj["2016_Elec_TWh_pct"]
        }
      })
    },

    setLocalStorageData: (state) => {
      let currentInputs = {
        'Natural Gas': state.ng_percent,
        'Geothermal': state.geothermal_percent,
        'Nuclear': state.nuclear_percent,
        'Petroleum': state.petroleum_percent,
        'Hydro': state.hydro_percent,
        'Biomass': state.biomass_percent,
        'Wind': state.wind_percent,
        'Solar PV': state.PV_percent,
        'Solar CSP': state.CSP_percent,
        'Coal': state.coal_percent,
        'Heating NG': state.heatingInputs['Natural Gas'].value,
        'Heating Elec': state.heatingInputs['Electricity'].value,
        'Heathing Other': state.heatingInputs['Other (e.g. Biomass, Petrol)'].value
      }
      if (localStorage.getItem(`${state.region_id}`) === null) {
        localStorage.setItem(`${state.region_id}`, JSON.stringify(currentInputs))
      } else {
        localStorage.removeItem(`${state.region_id}`);
        localStorage.setItem(`${state.region_id}`, JSON.stringify(currentInputs))
      }
    }
  }
});
